import { getTrackingContext, hasTrackingIdentity } from './context';
import { enqueue } from './queue';
import {
  TCartClickItemType,
  ITrackingEventInput,
  TTrackingEventType,
  TTrackingPayload,
} from './types';

const push = (type: TTrackingEventType, payload: TTrackingPayload): void => {
  if (!hasTrackingIdentity()) return; // no logged-in user → skip
  const event: ITrackingEventInput = {
    type,
    occurredAt: payload.date,
    payload,
  };
  enqueue(event);
};

const baseFields = () => {
  const { email, country } = getTrackingContext();
  return { date: new Date().toISOString(), email, country };
};

export const trackPv = (url: string = window.location.href): void => {
  push('pv', { ...baseFields(), action: 'pv', url });
};

export const trackCartAdd = (args: { lodgingUuid: string; type: 'accommodation' }): void => {
  push('cart-add', { ...baseFields(), action: 'cart-add', lodgingUuid: args.lodgingUuid, type: args.type });
};

export const trackCartClick = (args: {
  type: TCartClickItemType;
  itemUuid: string;
  itemLabel?: string | null;
  hotelUuid?: string | null;
  lodgingUuid?: string | null;
}): void => {
  push('cart-click', {
    ...baseFields(),
    action: 'cart-click',
    type: args.type,
    itemUuid: args.itemUuid,
    itemLabel: args.itemLabel ?? null,
    hotelUuid: args.hotelUuid ?? null,
    lodgingUuid: args.lodgingUuid ?? null,
  });
};

export const trackDateClick = (args: {
  lodgingUuid: string;
  fromDate?: string | null;
  toDate?: string | null;
}): void => {
  push('date-click', {
    ...baseFields(),
    action: 'date-click',
    lodgingUuid: args.lodgingUuid,
    fromDate: args.fromDate ?? null,
    toDate: args.toDate ?? null,
  });
};

export const trackSearchOutcome = (args: { top10: string[]; total: number }): void => {
  push('search-outcome', {
    ...baseFields(),
    action: 'search-outcome',
    top10: args.top10,
    total: args.total,
  });
};
